





















































import {Component, Watch, Mixins, Vue} from 'vue-property-decorator'
import {$, IResource, ObjectCollection} from 'simpli-web-sdk'
import {MixinFilter} from '@/components/mixins/MixinFilter'
import FilterDeliverySacGuest from '@/components/filters/FilterDeliverySacPublic.vue'
import DeliverySacPublicRequest from '@/model/request/DeliverySacPublicRequest'
import FilterToggle from '@/components/FilterToggle.vue'
import itTrackingSlider from '@/components/itrack/ItTrackingSlider.vue'
import * as Helper from '@/helpers'
import _ from 'lodash'
import { SacAgcoFilterType } from '@/enums/SacAgcoFilterType'

const metaInfo = () => ({
  title: $.t('view.reports.deliverySacPublic.title'),
})

@Component({
  metaInfo,
  components: {FilterDeliverySacGuest, FilterToggle, itTrackingSlider},
})
export default class ReportsDeliverySacAgcoPublicView extends Mixins(MixinFilter) {
  SacAgcoFilterType = SacAgcoFilterType

  filter = new DeliverySacPublicRequest()

  type: IResource | null = null
  options = new ObjectCollection(SacAgcoFilterType, 'enums.SacFilterType')
    .prependNull('view.reports.deliverySacPublic.selectDocType')

  @Watch('type', {deep: true})
  typeEvent() {
    this.filter = new DeliverySacPublicRequest()
  }

  submit() {
    if (!this.filter.isCleared) {
      const query = Helper.classToPlain(this.filter) as any

      this.$router.push({
        path: '/agco/result',
        query,
      })
    }
  }
}
